import { AxiosError } from "axios";
import { useSetAtom } from "jotai";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Intent } from "@/model";
import sentenceRepository from "@/repository/sentenceRepository";
import { intentQueryKeys } from "@/query/intent";
import { intentTableRefetchAtom } from "@/atom/intentTable";


export const useDeleteIntentSentence = (agentId: number, skillId?: number, intentId?: string, sentenceKey?: string) => {
    const queryClient = useQueryClient();
    const setIntentTableRefetch = useSetAtom(intentTableRefetchAtom);

    return useMutation<Intent, AxiosError>({
        mutationKey: ["intent-sentence", 'agent', agentId, "skill", skillId, "intent", intentId, "sentenceKey", sentenceKey, "delete"],
        mutationFn: async () => {
            try {
                const { data } = await sentenceRepository.delete(agentId, skillId!, intentId!, sentenceKey!);
                return data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            const intents = await queryClient.getQueryData(intentQueryKeys.intents(agentId, skillId)) as Intent[];

            intents.forEach(intent => {
                if (intent.id === intentId) {
                    intent.sentences = intent.sentences.filter(sentence => sentence.key !== sentenceKey);
                }
            });
            setIntentTableRefetch(true);
        }
    });
};
